<template>

    <div class="card border-0 text-center h-100 product" :id="'product-' + product.id">
        
        <div v-if="product.top_seller" class="position-absolute top-0 end-0 py-0 px-1 text-uppercase text-center bg-primary text-white small top-seller-badge">
            {{ __('Top-Seller') }}
        </div>
        
        <!--@todo id doppelt wenn teaser mehrfach auf seite in verschiedenen kontexten-->
        <div class="product__image">
            <img class="card-img-top product__image-file" :src="product.main_image_url" :alt="product.name" loading="lazy" />
        </div>
        <div class="card-body d-flex flex-column justify-content-between">
            <h3 class="card-title h6 mb-2" :class="{'placeholder-wave': loading}">
                <inertia-link :href="product.permalink" class="stretched-link link-dark" :class="{'placeholder': loading}">
                    {{ product.name }}
                </inertia-link>
            </h3>
            <div class="mb-2 product-supplier-number" v-if="product.supplier_pid">
                <div class="small">
                    <div class="small">
                        {{ __('Lieferanten-Artikelnr.') }}
                    </div>
                    <span class="text-black-50">
                        {{ product.supplier_pid }}
                    </span>
                </div>
            </div>
            <!--@todo ggf. separaten teaser für content produkte-->
            <div class="mb-2" v-if="product.template !== 'content'">
                <price-info :product="product" />
                <tax-info :product="product" />
                <delivery-info :product="product" />
            </div>
        </div>
    </div>

</template>


<script>
    import PriceInfo from '@/shared/PriceInfo';
    import TaxInfo from '@/shared/TaxInfo';
    import DeliveryInfo from '@/shared/DeliveryInfo';

    export default {
        props: [
            'product',
            'loading'
        ],
        data() {
            return {
            }
        },
        components: {
            PriceInfo,
            TaxInfo,
            DeliveryInfo,
        },
    }
</script>